// extracted by mini-css-extract-plugin
export default {"map":"MapComponent_map__6Lo0i"};